/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Nav_ServicesInputs */

const en_landing_nav_services = /** @type {(inputs: Landing_Nav_ServicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sessions`)
};

const pl_landing_nav_services = /** @type {(inputs: Landing_Nav_ServicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zajęcia`)
};

/**
* | output |
* | --- |
* | "Sessions" |
*
* @param {Landing_Nav_ServicesInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const landing_nav_services = /** @type {((inputs?: Landing_Nav_ServicesInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Nav_ServicesInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_landing_nav_services(inputs)
	return en_landing_nav_services(inputs)
});